module.exports = __webpack_public_path__ + "img/5W.54c8b4fc.png";